<div class="top">
  <h1 class="edit-group-modal-title">
    <span *ngIf="context.isAddingNewCategory">Add </span>
    <span *ngIf="!context.isAddingNewCategory">Edit </span>
    category
  </h1>
  <button class="btn btn-link close-x-btn" (click)="closeModal()">X</button>
</div>
<div class="fields">
  <text-area-input-element
    [label]="'Category name'"
    [rows]="1"
    [maxChars]="50"
    [hasExternalError]="checkForError()"
    [value]="context.groupData.displayAlias"
    (textAreaUpdated)="textAreaUpdated($event)"
  ></text-area-input-element>
  <div class="default-category">
    <mat-checkbox [(ngModel)]="isDefault"
      >Make this the default category</mat-checkbox
    >
    <mat-form-field *ngIf="context.groupData.isDefault && !isDefault">
      <!-- if we're editing a default group and we've decided we don't want it to be default anymore,
            show the dropdown to select a new default group -->
      <mat-select
        (selectionChange)="selectNewDefaultCategory()"
        [(ngModel)]="newDefaultCategory"
      >
        <mat-option *ngFor="let group of context.allGroups" [value]="group.id">
          {{ group.displayAlias }}
        </mat-option>
      </mat-select>
      <mat-placeholder>Select a new default category</mat-placeholder>
    </mat-form-field>
  </div>
</div>

<div *ngIf="hasError" class="submit-error">
  You need to select a new default category!
</div>
<div *ngIf="hasBlankNameError" class="submit-error">
  Category name can't be blank!
</div>
<div *ngIf="hasDuplicateGroupName" class="submit-error">
  Your new category name can't be the same as an existing category's name.
</div>
<div class="bottom-buttons">
  <button class="btn btn-lg btn-default" (click)="closeModal()">Close</button>
  <button
    class="btn btn-lg update"
    (click)="update()"
    [disabled]="hasDuplicateGroupName || hasBlankNameError"
  >
    Update
  </button>
</div>
